import { Component, Input, Inject, ViewChild } from "@angular/core";
import * as GoldenLayout from "golden-layout";

import * as tearSheetUtils from "@js/tear-sheet.utils";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { ChangeDetectorRef } from "@angular/core";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";
import { LISTING_IMAGE_COMPONENT_KEY } from "@app/components/editor/workspace/golden-layout-definitions";
import { Listing } from "@app/data/listing";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Pipe } from "@angular/core";
import { PipeTransform } from "@angular/core";
import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";

@Pipe({
  name: "renderImages",
  pure: false,
})
export class RenderImagesPipe implements PipeTransform {
  oldListingsString: string;
  oldStateString: string;
  templateHtml: SafeHtml;
  previewHtml: SafeHtml;
  constructor(private sanitizer: DomSanitizer) {}

  transform(state: any, listing: Listing, preview: boolean): any {
    var stateString = JSON.stringify(state);
    var listingsString = JSON.stringify(listing);
    if (
      !this.oldStateString ||
      stateString !== this.oldStateString ||
      listingsString !== this.oldListingsString
    ) {
      this.oldStateString = stateString;
      this.oldListingsString = listingsString;
      let html = tearSheetUtils.createImagesTemplate(state);
      this.templateHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(
        tearSheetUtils.replaceImages(html, listing)
      );
    }
    if (preview) {
      return this.previewHtml;
    }
    return this.templateHtml;
  }
}

@Component({
  templateUrl: "./golden-layout-listing-image.component.html",
})
export class GoldenLayoutListingImageComponent extends GoldenLayoutBaseComponent {
  listing: Listing;

  constructor(
    @Inject(GoldenLayoutComponentState) state: any,
    @Inject(GoldenLayoutContainer) container: GoldenLayout.Container,
    goldenLayoutService: GoldenLayoutService,
    cdRef: ChangeDetectorRef
  ) {
    super(state, container, goldenLayoutService, cdRef);
    this.state.additional_images_max_rows =
      this.state.additional_images_max_rows;
    this.state.additional_images_max_columns =
      this.state.additional_images_max_columns;
    this.state.style["background-size"] =
      this.state.style["background-size"] || "contain";
    this.goldenLayoutService.getListing().subscribe((listing) => {
      this.listing = listing;
    });
  }

  onClick() {
    this.select(LISTING_IMAGE_COMPONENT_KEY);
  }
}
